import EmblaCarousel from 'embla-carousel';
import AutoScroll from 'embla-carousel-auto-scroll';

function initMarquee( row ) {
	const viewportNode = row.querySelector( '.embla__viewport' );
	if ( ! viewportNode ) return null;

	const speedSec     = parseInt( row.dataset.speed, 10 )   || 30;
	const direction    = row.dataset.direction                || 'forward';
	const pauseOnHover = row.dataset.pause                   === 'true';

	// AutoScroll.speed = px/frame (~60 fps), pas px/s.
	// Formule : contentW / (speedSec * 60) = px/frame pour boucler en speedSec secondes.
	const container  = viewportNode.querySelector( '.embla__container' );
	const contentW   = container?.scrollWidth || 1000;
	const pxPerFrame = Math.max( 0.3, contentW / ( speedSec * 60 ) );

	const embla = EmblaCarousel(
		viewportNode,
		{
			loop:          true,
			dragFree:      true,
			containScroll: false,
			align:         'start',
		},
		[
			AutoScroll( {
				playOnInit:        true,
				speed:             pxPerFrame,
				direction,
				stopOnInteraction: false,
				stopOnMouseEnter:  pauseOnHover,
				startDelay:        0,
			} ),
		]
	);

	// Curseur grabbing global pendant le drag (souris hors du row)
	embla.on( 'pointerDown', () => document.documentElement.classList.add( 'ndg-marquee-dragging' ) );
	embla.on( 'pointerUp',   () => document.documentElement.classList.remove( 'ndg-marquee-dragging' ) );

	return embla;
}

// Initialisé à l'approche de l'écran et mis en pause hors champ : les mesures
// de l'init et le défilement continu ne pèsent plus sur le chargement de la
// page (le bloc est le plus souvent en bas de page).
document.addEventListener( 'DOMContentLoaded', () => {
	const instances = new WeakMap();

	const observer = new IntersectionObserver( ( entries ) => {
		entries.forEach( ( { target, isIntersecting } ) => {
			const embla = instances.get( target );

			if ( ! embla ) {
				if ( isIntersecting ) {
					const created = initMarquee( target );
					if ( created ) instances.set( target, created );
				}
				return;
			}

			const autoScroll = embla.plugins().autoScroll;
			if ( ! autoScroll ) return;
			if ( isIntersecting ) autoScroll.play();
			else autoScroll.stop();
		} );
	}, { rootMargin: '200px 0px' } );

	document.querySelectorAll( '[data-embla-marquee]' ).forEach( ( row ) => observer.observe( row ) );
} );
